<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg">
        <img
          [src]="currentStep === 1 ? 'assets/svg/task-icon-orange.svg' : getIconForTipo(tipoTareaSeleccionado)"
          alt=""
        />
      </div>
      <div>
        <h4 class="text-semibold">
          {{ currentStep === 1 ? 'Nueva tarea' : ' ' + getTipoNombre() }}
        </h4>
        <h6 class="color-gray" style="font-weight: 400">
          {{ currentStep === 1 ? 'Selecciona el tipo de tarea' : 'Agrega los
          detalles para registrar nueva tarea.' }}
        </h6>
      </div>
      <div>
        <img
          (click)="closeMdl()"
          class="close-button"
          src="assets/svg/close-icon.svg"
          alt=""
        />
      </div>
    </div>

    <div class="mdl-body">
      <div *ngIf="currentStep === 1" class="step-content">
        <div class="mt-3">
          <label class="login-label"
            ><p class="color-org d-inline">*</p>
            Tipo de tarea:</label
          >
          <div class="crm-ng-select">
            <ng-select
              [items]="tiposTarea"
              bindLabel="nombre"
              bindValue="valor"
              placeholder="Seleccione tipo de tarea"
              [(ngModel)]="tipoTareaSeleccionado"
              (change)="onTipoTareaChange()"
            >
              <ng-template ng-label-tmp let-item="item">
                <div class="selected-option">
                  <img
                    [src]="getIconForTipo(item.valor)"
                    alt="icono"
                    class="dropdown-icon"
                  />
                  <span>{{ item.nombre }}</span>
                </div>
              </ng-template>

              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div class="dropdown-option">
                  <img [src]="item.icono" alt="icono" class="dropdown-icon" />
                  <span>{{ item.nombre }}</span>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <div
        *ngIf="currentStep === 2 && tipoTareaSeleccionado === 'nueva_tarea'"
        class="step-content"
      >
        <h5 class="text-semibold mt-4">Información básica</h5>
        <div
          class="d-grid prospect-form"
          style="grid-template-columns: 1fr; column-gap: 32px"
        >
          <div>
            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Título tarea:</label
              >
              <input
                class="crm-input"
                type="text"
                placeholder="Ingresa el título de la nueva tarea"
                [(ngModel)]="taskData.title"
                required
              />
            </div>
            <div class="mt-3">
              <label class="login-label">Comentario / Notas:</label>
              <textarea
                class="crm-input"
                placeholder="Agrega notas o comentarios para la nueva tarea (opcional)"
                rows="3"
                [(ngModel)]="taskData.comment"
                style="height: 98px; resize: none"
              >
              </textarea>
            </div>
          </div>
        </div>

        <div
          class="d-grid prospect-form fixed-layout"
          style="
            grid-template-columns: 1fr 1fr;
            column-gap: 32px;
            align-items: start;
          "
        >
          <div class="left-column">
            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Estado:</label
              >
              <select class="crm-input" [(ngModel)]="taskData.status">
                <option value="">Selecciona el estado de la tarea</option>
                <option value="pendiente">Pendiente</option>
                <option value="en_progreso">En Progreso</option>
                <option value="vencida">Vencida</option>
                <option value="completada">Completada</option>
              </select>
            </div>

            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Asignar a:</label
              >
              <div class="crm-ng-select">
                <ng-select
                  [items]="ejecutivos"
                  bindLabel="nombre"
                  bindValue="valor"
                  placeholder="Buscar usuario..."
                  [(ngModel)]="taskData.assignedTo"
                  appendTo="body"
                  [disabled]="disableAssignSelect"
                >
                  <ng-template ng-label-tmp let-item="item">
                    <div class="selected-option">
                      <img
                        src="assets/svg/user-icon.svg"
                        alt="icono"
                        class="dropdown-icon"
                      />
                      <span>{{ item.nombre }}</span>
                    </div>
                  </ng-template>

                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div class="dropdown-option">
                      <img
                        src="assets/svg/user-icon.svg"
                        alt="icono"
                        class="dropdown-icon"
                      />
                      <span>{{ item.nombre }}</span>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>

            <div class="fecha-section fixed-position">
              <h5 class="text-semibold mt-4">Fecha de vencimiento</h5>

              <div class="mt-3">
                <label class="login-label">Fecha:</label>
                <input
                  class="crm-input"
                  type="date"
                  [(ngModel)]="taskData.dueDate"
                  [value]="getTodayDate()"
                />
              </div>

              <div class="mt-3 d-flex align-items-center gap-5">
                <label class="login-label"
                  ><p class="color-org d-inline">*</p>
                  Repetir esta tarea:</label
                >
                <input
                  type="checkbox"
                  id="repeatTask"
                  [(ngModel)]="taskData.repeatTask"
                  (change)="onRepeatTaskChange()"
                  style="
                    margin-left: 15px;
                    transform: translateY(-2px);
                    color: #ea5a10;
                  "
                />
              </div>

              <div *ngIf="showRepeatOptions" class="mt-3">
                <div class="mt-3">
                  <label class="login-label"
                    ><p class="color-org d-inline">*</p>
                    Frecuencia:</label
                  >
                  <select class="crm-input" [(ngModel)]="taskData.frecuencia">
                    <option value="">Selecciona la frecuencia</option>
                    <option value="diaria">Diaria</option>
                    <option value="semanal">Semanal</option>
                    <option value="mensual">Mensual</option>
                    <option value="anual">Anual</option>
                    <option value="personalizadoTR">
                      Personaliza fecha y hora
                    </option>
                  </select>
                </div>

                <div class="d-flex gap-3 mt-3">
                  <div style="flex: 1; margin-right: 12px">
                    <label class="login-label"
                      ><p class="color-org d-inline">*</p>
                      Fecha inicio:</label
                    >
                    <input
                      class="crm-input"
                      type="date"
                      [(ngModel)]="taskData.fechaInicio"
                      [value]="getTodayDate()"
                    />
                  </div>
                  <div style="flex: 1">
                    <label class="login-label"
                      ><p class="color-org d-inline">*</p>
                      Fecha fin:</label
                    >
                    <input
                      class="crm-input"
                      type="date"
                      [(ngModel)]="taskData.fechaFin"
                      [value]="getTodayDate()"
                    />
                  </div>
                </div>

                <div class="d-flex gap-3 mt-3">
                  <div style="flex: 1; margin-right: 12px">
                    <label class="login-label"
                      ><p class="color-org d-inline">*</p>
                      Hora inicio:</label
                    >
                    <input
                      class="crm-input"
                      type="time"
                      [(ngModel)]="taskData.horaInicio"
                      value="10:00"
                    />
                  </div>
                  <div style="flex: 1">
                    <label class="login-label"
                      ><p class="color-org d-inline">*</p>
                      Hora fin:</label
                    >
                    <input
                      class="crm-input"
                      type="time"
                      [(ngModel)]="taskData.horaFin"
                      value="10:00"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="fecha-space-reserved"></div>
          </div>

          <div class="right-column">
            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Prioridad:</label
              >
              <select class="crm-input" [(ngModel)]="taskData.priority">
                <option value="">Selecciona la prioridad de la tarea</option>
                <option value="Baja">Baja</option>
                <option value="Media">Media</option>
                <option value="Alta">Alta</option>
              </select>
            </div>

            <div class="mt-3">
              <label class="login-label">
                <p class="color-org d-inline">*</p>
                Relacionado con:
              </label>

              <div class="relacionado-container">
                <div class="tipo-selector">
                  <select
                    class="crm-input"
                    [(ngModel)]="tipoRelacionado"
                    (change)="onTipoRelacionadoChange()"
                  >
                    <option value="">Selecciona tipo</option>
                    <option value="PRO">Prospecto</option>
                    <option value="CNT">Contacto</option>
                    <option value="ACC">Cuenta</option>
                    <option value="OPP">Oportunidad</option>
                  </select>
                </div>

                <div
                  class="elemento-selector"
                  *ngIf="tipoRelacionado && tipoRelacionado !== 'OTRO'"
                >
                  <div class="crm-ng-select">
                    <ng-select
                      [items]="elementosFiltrados"
                      bindLabel="nombre"
                      bindValue="valor"
                      [placeholder]="getPlaceholderPorTipo()"
                      [(ngModel)]="taskData.relatedTo"
                      [clearable]="true"
                      appendTo="body"
                      (clear)="limpiarSeleccionRelacionado()"
                    >
                      <ng-template ng-label-tmp let-item="item">
                        <div class="selected-option">
                          <img
                            [src]="getIconForTipoRelacionado(tipoRelacionado)"
                            alt="icono"
                            class="dropdown-icon"
                          />
                          <span class="option-text"
                            >{{ item ? item.nombre : getPlaceholderPorTipo()
                            }}</span
                          >
                        </div>
                      </ng-template>

                      <ng-template
                        ng-option-tmp
                        let-item="item"
                        let-index="index"
                      >
                        <div class="dropdown-option">
                          <img
                            [src]="getIconForTipoRelacionado(tipoRelacionado)"
                            alt="icono"
                            class="dropdown-icon"
                          />
                          <span class="option-text">{{ item.nombre }}</span>
                        </div>
                      </ng-template>

                      <ng-template ng-notfound-tmp>
                        <div class="ng-option disabled">
                          No se encontraron {{ getTipoDisplay() }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>

            <div class="hora-section fixed-position">
              <div class="mt-3">
                <label class="login-label"
                  ><p class="color-org d-inline">*</p>
                  Hora:</label
                >
                <input
                  class="crm-input"
                  type="time"
                  [(ngModel)]="taskData.dueTime"
                  value="10:00"
                />
              </div>

              <div class="mt-3 d-flex align-items-center gap-5">
                <label class="login-label"
                  ><p class="color-org d-inline">*</p>
                  Recordatorio establecido:</label
                >
                <input
                  type="checkbox"
                  id="reminderCheckbox"
                  [(ngModel)]="taskData.reminderEnabled"
                  (change)="onReminderEnabledChange()"
                  style="margin-left: 15px; transform: translateY(-2px)"
                />
              </div>

              <div *ngIf="showReminderOptions" class="mt-3">
                <div class="mt-3">
                  <label class="login-label"
                    ><p class="color-org d-inline">*</p>
                    Tiempo del recordatorio:</label
                  >
                  <select
                    class="crm-input"
                    [(ngModel)]="taskData.tiempoRecordatorio"
                  >
                    <option value="">
                      Selecciona el tiempo del recordatorio
                    </option>
                    <option value="5min">5 minutos antes</option>
                    <option value="15min">15 minutos antes</option>
                    <option value="30min">30 minutos antes</option>
                    <option value="1h">1 hora antes</option>
                    <option value="1d">1 día antes</option>
                    <option value="2d">2 día antes</option>
                    <option value="personalizadoFR">
                      Personalizar fecha y hora
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="hora-space-reserved"></div>
          </div>
        </div>
      </div>

      <div
        *ngIf="currentStep === 2 && tipoTareaSeleccionado === 'nueva_llamada'"
        class="step-content"
      >
        <h5 class="text-semibold mt-4">Información de la llamada</h5>
        <div
          class="d-grid prospect-form"
          style="grid-template-columns: 1fr; column-gap: 32px"
        >
          <div>
            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Asunto:</label
              >
              <input
                class="crm-input"
                type="text"
                placeholder="Ingresa el asunto de la llamada"
                [(ngModel)]="taskData.title"
                required
              />
            </div>
            <div class="mt-3">
              <label class="login-label">Comentario / Notas:</label>
              <textarea
                class="crm-input"
                placeholder="Agrega notas o comentarios sobre la llamada (opcional)"
                rows="3"
                [(ngModel)]="taskData.comment"
                style="height: 98px; resize: none"
              ></textarea>
            </div>
          </div>
        </div>

        <div
          class="d-grid prospect-form"
          style="
            grid-template-columns: 1fr 1fr;
            column-gap: 32px;
            align-items: start;
          "
        >
          <div>
            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Estado:</label
              >
              <select class="crm-input" [(ngModel)]="taskData.status">
                <option value="">Selecciona el estado de la llamada</option>
                <option value="pendiente">Pendiente</option>
                <option value="vencida">Vencida</option>
                <option value="completada">Completada</option>
              </select>
            </div>

            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Asignar a:</label
              >
              <div class="crm-ng-select">
                <ng-select
                  [items]="ejecutivos"
                  bindLabel="nombre"
                  bindValue="valor"
                  placeholder="Buscar usuario..."
                  [(ngModel)]="taskData.assignedTo"
                  appendTo="body"
                  [disabled]="disableAssignSelect"
                >
                  <ng-template ng-label-tmp let-item="item">
                    <div class="selected-option">
                      <img
                        src="assets/svg/user-icon.svg"
                        alt="icono"
                        class="dropdown-icon"
                      />
                      <span>{{ item.nombre }}</span>
                    </div>
                  </ng-template>

                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div class="dropdown-option">
                      <img
                        src="assets/svg/user-icon.svg"
                        alt="icono"
                        class="dropdown-icon"
                      />
                      <span>{{ item.nombre }}</span>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>

            <div class="mt-3">
              <h5 class="text-semibold" style="padding-top: 21px">
                Fecha programada
              </h5>
              <label class="login-label">Fecha:</label>
              <input
                class="crm-input"
                type="date"
                [(ngModel)]="taskData.dueDate"
                [value]="getTodayDate()"
              />
            </div>
          </div>

          <div>
            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Prioridad:</label
              >
              <select class="crm-input" [(ngModel)]="taskData.priority">
                <option value="">Selecciona la prioridad</option>
                <option value="Baja">Baja</option>
                <option value="Media">Media</option>
                <option value="Alta">Alta</option>
              </select>
            </div>

            <div class="mt-3">
              <label class="login-label">
                <p class="color-org d-inline">*</p>
                Relacionado con:
              </label>

              <div class="relacionado-container">
                <div class="tipo-selector">
                  <select
                    class="crm-input"
                    [(ngModel)]="tipoRelacionado"
                    (change)="onTipoRelacionadoChange()"
                    [disabled]="disabledSelect"
                  >
                    <option value="">Selecciona tipo</option>
                    <option value="PRO">Prospecto</option>
                    <option value="CNT">Contacto</option>
                    <option value="ACC">Cuenta</option>
                    <option value="OPP">Oportunidad</option>
                  </select>
                </div>

                <div
                  class="elemento-selector"
                  *ngIf="tipoRelacionado && tipoRelacionado !== 'OTRO'"
                >
                  <div class="crm-ng-select">
                    <ng-select
                      [items]="elementosFiltrados"
                      bindLabel="nombre"
                      bindValue="valor"
                      [placeholder]="getPlaceholderPorTipo()"
                      [(ngModel)]="taskData.relatedTo"
                      [clearable]="true"
                      appendTo="body"
                      (clear)="limpiarSeleccionRelacionado()"
                      [disabled]="disabledSelect"
                    >
                      <ng-template ng-label-tmp let-item="item">
                        <div class="selected-option">
                          <img
                            [src]="getIconForTipoRelacionado(tipoRelacionado)"
                            alt="icono"
                            class="dropdown-icon"
                          />
                          <span class="option-text"
                            >{{ item ? item.nombre : getPlaceholderPorTipo()
                            }}</span
                          >
                        </div>
                      </ng-template>

                      <ng-template
                        ng-option-tmp
                        let-item="item"
                        let-index="index"
                      >
                        <div class="dropdown-option">
                          <img
                            [src]="getIconForTipoRelacionado(tipoRelacionado)"
                            alt="icono"
                            class="dropdown-icon"
                          />
                          <span class="option-text">{{ item.nombre }}</span>
                        </div>
                      </ng-template>

                      <ng-template ng-notfound-tmp>
                        <div class="ng-option disabled">
                          No se encontraron {{ getTipoDisplay() }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Hora:</label
              >
              <input
                class="crm-input"
                type="time"
                [(ngModel)]="taskData.dueTime"
                value="10:00"
              />
            </div>
          </div>
        </div>

        <div class="mt-4">
          <h5 class="text-semibold">Detalles de la llamada</h5>
          <div
            class="d-grid prospect-form"
            style="
              grid-template-columns: 1fr 1fr;
              column-gap: 32px;
              align-items: start;
            "
          >
            <div>
              <div class="mt-3">
                <label class="login-label">Teléfono:</label>
                <input
                  class="crm-input"
                  type="text"
                  placeholder="Número de teléfono"
                  [(ngModel)]="taskData.telefono"
                />
              </div>
            </div>

            <div>
              <div class="mt-3">
                <label class="login-label">Tipo de llamada:</label>
                <select class="crm-input" [(ngModel)]="taskData.tipoLlamada">
                  <option value="">Selecciona el tipo</option>
                  <option value="entrante">Entrante</option>
                  <option value="saliente">Saliente</option>
                </select>
              </div>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label">Resultado:</label>
            <textarea
              class="crm-input"
              placeholder="Describe el resultado de la llamada"
              rows="2"
              [(ngModel)]="taskData.resultado"
              style="height: 70px; resize: none"
            ></textarea>
          </div>
        </div>
      </div>

      <div
        *ngIf="currentStep === 2 && tipoTareaSeleccionado !== 'nueva_tarea' && tipoTareaSeleccionado !== 'nueva_llamada'"
        class="step-content"
      >
        <h5 class="text-semibold mt-4">
          Configuración de {{ getTipoNombre() }}
        </h5>
        <div
          class="d-grid prospect-form"
          style="grid-template-columns: 1fr 1fr; column-gap: 32px"
        >
          <div>
            <div class="mt-3">
              <label class="login-label"
                >Configuración para {{ getTipoNombre() }}:</label
              >
              <p class="color-gray">
                La configuración específica para {{ getTipoNombre() }} estará
                disponible próximamente.
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr class="mt-5 mb-5" />

      <div class="d-flex flex-row justify-center gap-20 mt-2">
        <button
          class="btn btn-primary-outline"
          (click)="currentStep === 1 ? closeMdl() : previousStep()"
        >
          {{ currentStep === 1 ? 'Cancelar' : 'Cancelar' }}
        </button>

        <button
          *ngIf="currentStep === 1"
          class="btn btn-primary"
          (click)="siguiente()"
          [disabled]="!tipoTareaSeleccionado"
        >
          Siguiente
        </button>

          <button 
        *ngIf="currentStep === 2"
        class="btn btn-primary"
        (click)="data?.mode === 'edit' ? actualizarTarea() : crearTarea()"
      >
        {{ data?.mode === 'edit' ? 'Guardar cambios' : getTextoBotonCrear() }}
      </button>
      </div>
    </div>
  </div>
</div>
